import React from 'react';
import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface AuthLegalNoticeProps {
  creatingAccount?: boolean;
}

const AuthLegalNotice: React.FC<AuthLegalNoticeProps> = ({ creatingAccount = false }) => (
  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.7 }}>
    {creatingAccount ? 'By creating an account, you agree to our ' : 'By signing in, you agree to our '}
    <Link component={RouterLink} to="/terms" underline="hover">Terms of Service</Link>
    {' and acknowledge our '}
    <Link component={RouterLink} to="/privacy" underline="hover">Privacy Policy</Link>.
  </Typography>
);

export default AuthLegalNotice;
